// extracted by mini-css-extract-plugin
export default {"title":"a4-z","warning":"b4-z","sizeOptionsLegendText":"c4-z"};